import React from 'react'
import { RadioGroup } from '@material-ui/core'

const ControlledRadioGroup = ({ value, onChange, children }) => {
  const handleChange = (event) => {
    onChange(parseInt(event.target.value))
  }

  return (
    <RadioGroup value={parseInt(value || 0)} onChange={handleChange}>
      {children}
    </RadioGroup>
  )
}
export default ControlledRadioGroup
